import api from "../api/client";

const freightFinancialApi = {
  getByFreightId(freightId) {
    return api.get(`/freight/${freightId}/financial`);
  },

  update(freightId, payload) {
    return api.patch(`/freight/${freightId}/financial`, payload);
  },

  uploadBoleto(freightId, file, installmentNumber) {
    const formData = new FormData();
    formData.append("file", file);
    if (installmentNumber != null) {
      formData.append("installmentNumber", String(installmentNumber));
    }
    return api.post(`/freight/${freightId}/financial/boleto`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  removeBoleto(freightId, installmentNumber) {
    const params =
      installmentNumber != null ? { installmentNumber } : undefined;
    return api.delete(`/freight/${freightId}/financial/boleto`, { params });
  },

  sendBoleto(freightId) {
    return api.post(`/freight/${freightId}/financial/send-boleto`);
  },

  charge(freightId) {
    return api.post(`/freight/${freightId}/financial/charge`);
  },
};

export default freightFinancialApi;
